export enum TableAgeType {
  Distance = 'distance',
  DateTime = 'date-time',
}
